'use client';

import { Alert, Button, Box, Typography } from '@mui/material';
import { useImpersonation } from '@/hooks/useImpersonation';
import { useSession } from 'next-auth/react';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';

export default function ImpersonationBanner() {
  const { data: session } = useSession();
  const { stopImpersonation, loading, originalUser } = useImpersonation();

  if (!session?.user?.isImpersonating || !originalUser) {
    return null;
  }

  const handleStopImpersonation = async () => {
    await stopImpersonation();
  };

  return (
    <Alert
      severity="warning"
      sx={{
        mb: 2,
        '& .MuiAlert-message': {
          width: '100%',
        },
      }}
      action={
        <Button
          color="inherit"
          size="small"
          onClick={handleStopImpersonation}
          disabled={loading}
          startIcon={<ExitToAppIcon />}
          sx={{ whiteSpace: 'nowrap' }}
        >
          {loading ? 'Stopping...' : 'Stop Impersonation'}
        </Button>
      }
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Typography variant="body2">
          <strong>Impersonation Active:</strong> You are acting as{' '}
          <strong>{session.user.name}</strong> ({session.user.email}).
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Original user: {originalUser.name} ({originalUser.email})
        </Typography>
      </Box>
    </Alert>
  );
} 